/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ProfileImage/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import Avatar from 'DesignSystem/Avatar/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ProfileImage({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Email/Emails/Content/Email/Edit/Content/EditOrAdd/Content/Content/Profiles/Content/Profile/ProfileImage",
  presignedUrl
  
}) {
let personValueData = fromData.useDataFormat({ viewPath,
context: 'person',
format: fromFormat.initials,
})
  return (<React.Fragment
>
<Avatar
  viewPath={`${viewPath}/Avatar`}
 profile_url={presignedUrl}
 data="person"
 format="/Data/format.js initials"
 initials={personValueData}
 size="medium"
/>
{children}
</React.Fragment>)
}